var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendChatA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=active"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 5",
    cx: 21.3636,
    cy: 20,
    rx: 20.4545,
    ry: 20,
    fill: "#825DFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M29.6704 11.5296L19.0064 22.1936M11.8711 16.8353L28.477 11.074C29.4996 10.7192 30.4808 11.7004 30.126 12.723L24.3647 29.3289C23.9701 30.4665 22.3726 30.4977 21.9338 29.3764L19.2969 22.6376C19.1652 22.3011 18.8989 22.0348 18.5624 21.9031L11.8236 19.2662C10.7023 18.8274 10.7335 17.2299 11.8711 16.8353Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChatA);
export default __webpack_public_path__ + "static/media/send_chat_a.346129369af7ccf2318249927b18c037.svg";
export { ForwardRef as ReactComponent };